import type { Options } from 'pusher-js';

export interface PusherEnv {
  key?: string;
  cluster?: string;
  host?: string;
  port?: string;
}

export function buildPusherClientOptions(
  env: PusherEnv,
  authorizer: Options['authorizer']
): Options {
  if (env.host) {
    const port = env.port ? Number(env.port) : 6001;
    return {
      wsHost: env.host,
      wsPort: port,
      wssPort: port,
      forceTLS: false,
      enabledTransports: ['ws', 'wss'],
      disableStats: true,
      // pusher-js still wants a cluster string even when wsHost is set; it is
      // unused for host resolution. Fall back to a placeholder so the type holds.
      cluster: env.cluster || 'local',
      authorizer,
    };
  }

  return {
    cluster: env.cluster as string,
    forceTLS: true,
    authorizer,
  };
}
